import { freeze, assocIn } from 'icepick';
import { SET_LOCATION_SUCCESS } from '../new-location/new-location-action-type.tsx';
import { CANCEL_DIALOG, INIT_DIALOG } from './dialog-action-type.tsx';

const initialState = freeze({
	isOpen: true,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialogReducer = (state = initialState, action: any) => {
	const { type } = action;

	switch (type) {
		case INIT_DIALOG:
			return assocIn(state, ['isOpen'], true);
		case CANCEL_DIALOG:
		case SET_LOCATION_SUCCESS:
			return assocIn(state, ['isOpen'], false);
		default:
			return state;
	}
};

export default dialogReducer;
